import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from 'i18next-http-backend';
import en from "./assets/locales/en/translation.json"
import vi from "./assets/locales/vi/translation.json"

const resources = {
    en : {
        translation : en
    },
    vi : {
        translation : vi
    }
}

i18next
.use(initReactI18next)
.use(LanguageDetector)
.use(Backend)
.init({
    // debug : true,
    fallbackLng : "en",
    supportedLngs : ["en", "vi"],
        nonExplicitSupportedLngs : false, // "uploads", "features", ... sẽ bị loại, không được nhận là ngôn ngữ
    resources,
    detection : {
    order: ['path', 'localStorage', 'htmlTag', 'cookie'],
        caches : ['localStorage']
    },
    interpolation: {
        escapeValue: false // not needed for react as it escapes by default
    }
    
    
    // backend : {
    //     loadPath : 'assets/locales/{{lng}}/translation'
    // },
    
    
})

